/**
 * Created by erikuusitalo on 03/07/16.
 */
+(function ($) {

  var containerWidth = $('.container').width;

  $( '#my-slider' ).sliderPro({
    width: containerWidth,
    height: 480,
    arrows: true,
    fadeArrows: false,
    buttons: false
  });

})(jQuery);
